import { getRouteApi } from '@tanstack/react-router';

import { useProjectMedia } from '@/api/media';
import Spinner from '@/components/ui/spinner';

import { FloorPlansCard } from './media-cards/floorplans-card';
import { ImagesCard } from './media-cards/images-card';

const route = getRouteApi('/_authenticated/_sidebar-layout/projects/$projectId');

export const MediaDatabase = () => {
  const { projectId } = route.useParams();
  const { data, isPending } = useProjectMedia({ id: projectId });

  const layouts = Object.values(data.layouts);
  const images = Object.values(data.images);

  if (isPending) {
    return <Spinner />;
  }

  return (
    <div className="grid grid-cols-3 gap-4 max-sm:grid-cols-1 xl:grid-cols-4">
      <ImagesCard data={images} projectId={projectId} />
      <FloorPlansCard data={layouts} projectId={projectId} />
    </div>
  );
};
